<script>
import InputTextEditor from '@/components(new)/UI/Forms/InputTextEditor/InputTextEditor.vue'
import DocumentUpload from '@/components(new)/UI/Forms/DocumentUpload/DocumentUpload.vue'
import VisualizarCadastro from '@/components(new)/UI/Modals/VisualizacaoCadastro/VisualizarCadastro.vue'
import AppButtonsCadastroSicarf from '@/components(new)/UI/Buttons/ButtonsCadastroSicarf/ButtonsCadastroSicarf.vue'
import AppNotificacao from '@/components/mixins/AppNotificacao.vue'
import InputRadio from '@/components(new)/UI/Forms/InputRadio/InputRadio.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    InputTextEditor,
    DocumentUpload,
    VisualizarCadastro,
    AppButtonsCadastroSicarf,
    InputRadio
  },

  mixins: [
    AppNotificacao
  ],

  async created () {
    const [infoAnalise, acoes] = await Promise.all([this.getInfoAnaliseById(this.$route.params.id), this.getAcoesTramitacaoById(this.$route.params.id)])

    this.infoAnalise = infoAnalise
    this.acoes = acoes.map(acao => ({id: acao.id, nome: acao.descricao}))
  },
  beforeRouteLeave (to, from, next) {
    if (this.showAvisoVoltar) {
      this.throwAvisoVoltar(() => next(), () => next(false))
    } else {
      next()
    }
  },
  data () {
    return {
      infoAnalise: {
        protocolo: null,
        numeroProcesso: null,
        despacho: null
      },
      acoes: [],
      acaoSelecionada: null,
      showAvisoVoltar: true
    }
  },
  computed: {
    isPrimeiroPasso () {
      return true
    },
    isUltimoPasso () {
      return true
    },
    showButtonProximo () {
      return false
    },
    showButtonCancelar () {
      return true
    },
    showButtonSalvar () {
      return true
    }
  },
  methods: {
    ...mapActions({
      getInfoAnaliseById: 'processo/getInfoAnaliseById',
      getAcoesTramitacaoById: 'processo/getAcoesTramitacaoById',
      salvarDespacho: 'despacho/salvar',
      finalizarDespacho: 'despacho/finalizar'
    }),
    navigateBack () {
      if (this.$route.meta?.previousRoute?.meta?.routeGroup) {
        this.$router.push({ name: this.$route.meta?.previousRoute?.meta?.routeGroup })
        return
      }
      this.$router.back()
    },
    voltar () {
      this.navigateBack()
    },
    cancelar () {
      this.navigateBack()
    },
    throwAvisoVoltar (callbackAccept, callbackReject) {
      this.confirmBox('Você tem certeza que deseja cancelar? Todos os dados não salvos serão perdidos.', this.$messages.TITULO_WARNING,
        () => {
          if (callbackAccept) {
            this.showAvisoVoltar = false
            callbackAccept()
          }
        },
        () => {
          if (callbackReject) {
            callbackReject()
          }
        }, 'Sim', 'Não')
    },
    async salvar (showMessage = true) {
      this.infoAnalise.despacho = await this.salvarDespacho(this.infoAnalise.despacho)
      if (showMessage) {
        this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Análise salva com sucesso.')
      }
    },
    async finalizar () {
      await this.salvar(false)

      if (!await this.$refs.observer.validate()) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERRO_VALIDACAO_CAMPOS_OBRIGATORIOS
        )
        return
      }

      await this.finalizarDespacho({ acao: this.acaoSelecionada, despacho: this.infoAnalise.despacho })

      this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Análise finalizada com sucesso.')
      this.showAvisoVoltar = false
      this.navigateBack()
    },
    uploadFile (file) {
      this.infoAnalise.despacho.documentos.push({
        key: file.response,
        nome: file.name,
        tipo: {
          codigo: 'ANEXO_ANALISE'
        }
      })
    },
    async removeFile (documento) {
      this.confirmBox(
        this.$messages.DOCUMENTO_REMOVE_CONFIRM,
        this.$messages.TITULO_WARNING,
        () => {
          this.deleteDocumento(documento)
        },
        () => {}
      )
    },
    deleteDocumento (documento) {
      const compare = documento.id ? 'id' : 'key'
      const index = this.infoAnalise.despacho.documentos.indexOf(
        this.infoAnalise.despacho.documentos.findIndex(a => a[compare] === documento[compare])
      )
      this.infoAnalise.despacho.documentos.splice(index, 1)
    }
  }
}
</script>

<template>
  <div class="container" v-if="infoAnalise.despacho">
    <div class="flex-row gap-2 mt-15px">
      <el-button
        @click="voltar"
        class="flex-center w-45px h-30px"
        type="primary"
      >
        <i class="fas fa-chevron-left"></i>
      </el-button>
      <span class="font-20px font-weight-600">Voltar</span>
    </div>
    <visualizar-cadastro
      v-if="infoAnalise.protocolo"
      :protocolo="infoAnalise.protocolo"
      cadastroContainerCustomClasses="card border-radius-4px bg-light-grey"/>
    <el-card>
      <validation-observer ref="observer">
        <input-text-editor
          label="Despacho"
          v-model="infoAnalise.despacho.texto"
          validationRules="required"
        />
        <document-upload
          id="anexos-despacho"
          :files="infoAnalise.despacho.documentos"
          @uploadFile="uploadFile"
          @removeFile="removeFile"
        />
        <div class="mt-3 mb-1 flex-center">
          <input-radio v-if="acoes && acoes.length"
            :options="acoes"
            v-model="acaoSelecionada"
          />
        </div>
      </validation-observer>
    </el-card>
    <app-buttons-cadastro-sicarf
      :isIntroPasso="false"
      :isPrimeiroPasso="isPrimeiroPasso"
      :isUltimoPasso="isUltimoPasso"
      :showButtonCancelar="showButtonCancelar"
      :showButtonProximo="showButtonProximo"
      :showButtonSalvar="showButtonSalvar"
      @salvar="salvar"
      @cancelar="cancelar"
      @finalizar="finalizar"
    />
  </div>
</template>

<style lang="scss" scoped>
  @import './styles.scss';
</style>



// WEBPACK FOOTER //
// src/App/(authenticated)/modulos/analise/sala-monitoramento/analise-processo/analise-processo.vue